import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { initSentry } from '@/lib/observability';

const COOKIE_CONSENT_KEY = 'cd:cookie-consent-v1';

export default function CookieBanner() {
  const [hidden, setHidden] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
      if (stored) setHidden(true);
    } catch (_e) {}
  }, []);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') setHidden(true);
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);

  if (hidden) return null;

  const handleAccept = () => {
    try {
      localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
        accepted: true,
        at: new Date().toISOString(),
      }));
    } catch (_e) {}
    initSentry();
    setHidden(true);
  };

  const handleManage = () => {
    setHidden(true);
    navigate('/nastavenia');
  };

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-banner"
      className="cd-cookie-banner"
      style={{
        position: 'fixed',
        bottom: 16, left: 16, right: 16,
        maxWidth: 880, margin: '0 auto',
        background: 'var(--bg-surface)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--r-lg)',
        padding: '14px 18px',
        boxShadow: '0 12px 32px rgba(0,0,0,0.15)',
        zIndex: 1500,
        display: 'flex', alignItems: 'center', gap: 14,
        fontFamily: 'inherit',
      }}
    >
      <div
        aria-hidden="true"
        className="cd-cookie-banner-icon"
        style={{
          width: 38, height: 38, borderRadius: '50%',
          background: 'var(--sec-yellow-soft)',
          flexShrink: 0,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="var(--sec-yellow)" strokeWidth="1.8"
          strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5z" />
          <circle cx="9" cy="11" r="0.6" fill="var(--sec-yellow)" stroke="none" />
          <circle cx="14" cy="14" r="0.6" fill="var(--sec-yellow)" stroke="none" />
          <circle cx="11" cy="16" r="0.6" fill="var(--sec-yellow)" stroke="none" />
        </svg>
      </div>

      <div className="cd-cookie-banner-body" style={{ flex: 1, minWidth: 0 }}>
        <div className="cd-cookie-banner-title" style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>
          Trochu súkromia, trochu pomoci
        </div>
        <div className="cd-cookie-banner-text" style={{ fontSize: 12, color: 'var(--text-secondary)', lineHeight: 1.5 }}>
          Používame iba nevyhnutné technické cookies (prihlásenie, aktívna firma).
          Ak si zapneš <strong>anonymný benchmarking</strong> v Nastaveniach, pomôžeš
          nám zlepšovať appku — žiadne osobné údaje.
          {' '}
          <a href="/privacy" style={{ color: 'var(--product-primary-hover)', textDecoration: 'underline' }}>
            Zásady ochrany osobných údajov
          </a>.
        </div>
      </div>

      <div className="cd-cookie-banner-actions" style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <button
          type="button"
          onClick={handleManage}
          data-testid="cookie-banner-manage"
          style={{
            padding: '8px 14px', borderRadius: 'var(--r-md)',
            border: '1px solid var(--border)', background: 'var(--bg-base)',
            color: 'var(--text-primary)', cursor: 'pointer',
            fontSize: 12, fontWeight: 600, fontFamily: 'inherit',
          }}
        >
          Spravovať
        </button>
        <button
          type="button"
          onClick={handleAccept}
          data-testid="cookie-banner-accept"
          style={{
            padding: '8px 14px', borderRadius: 'var(--r-md)',
            border: 'none', background: 'var(--product-primary)',
            color: '#fff', cursor: 'pointer',
            fontSize: 12, fontWeight: 600, fontFamily: 'inherit',
          }}
        >
          Rozumiem
        </button>
      </div>
    </div>
  );
}
